module.exports = __webpack_public_path__ + "img/close.55d64dd5.svg";